import { useMemo } from 'react';
import { isNullOrWhitespace } from 'js/utils/string';

export function useHasValue(value) {
  return useMemo(() => !isNullOrWhitespace(value), [value]);
}
